/**
 * A secret shown once, with Copy and "I've saved it". The API keeps only a hash or a sealed copy, so this is the one
 * chance to take it: a webhook's signing secret, a personal MCP token.
 */
import { useState, type ReactNode } from 'react'

export function SecretOnce({
  message,
  secret,
  hint,
  copyLabel = 'Copy secret',
  onDone,
}: {
  /** What was made and why to copy it now. */
  message: ReactNode
  secret: string
  /** One line under the secret: where it goes. */
  hint?: ReactNode
  copyLabel?: string
  onDone: () => void
}) {
  const [copied, setCopied] = useState(false)
  return (
    <div className="secret-once" role="status">
      <p>{message}</p>
      <code className="cmd secret">{secret}</code>
      {hint && <p className="hint">{hint}</p>}
      <div className="row-btns">
        <button
          type="button"
          className="btn btn-soft btn-xs"
          onClick={() => void navigator.clipboard?.writeText(secret).then(() => setCopied(true), () => setCopied(false))}
        >
          {copied ? 'Copied' : copyLabel}
        </button>
        <button type="button" className="btn btn-ink btn-xs" onClick={onDone}>
          I've saved it
        </button>
      </div>
    </div>
  )
}
